// src/firebaseMessagingHandler.js
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase';
import { store } from './app/store';

export function setupFirebaseMessaging() {
  console.log("heyyyyy333")
  onMessage(messaging, (payload) => {
    console.log("heyyyy2222y")
    console.log(payload, 'payload 009jjjjjjjjjjjjjjjjjyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy')
    const state = store.getState();
    const currentChatId = state.chat.openChatId;
    const incomingChatId = payload.data?.agreementId;
    
    if (currentChatId !== incomingChatId) {
      console.log("heyyyyy44444")
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: '/chat-icon.png',
        data: {
          agreementId: incomingChatId,
        },
      });
    } else {
      console.log("heyyyyy5555555555")
      console.log('Chat is already open. No notification shown.');
    }
  });
}
